import { render } from "./Actions.vue?vue&type=template&id=d13f1bc8"
import script from "./Actions.vue?vue&type=script&lang=js"
export * from "./Actions.vue?vue&type=script&lang=js"
script.render = render

export default script